// Import depuis les CDN (disponibles globalement)
// import { PDFFont, rgb } from "pdf-lib/cjs/api";

// Types globaux définis dans src/types/global.d.ts

/**
 * Truncate a text it is too long
 */
export const truncateText = (
  text: string,
  width: number,
  font: any, // Changed from PDFFont to any
  fontSize: number
): string => {
  // Truncate le titre si trop long
  let truncatedText = text;
  // si le text fini par "..." on le supprime
  if (text.endsWith("...")) {
    text = text.substring(0, text.length - 3);
  }

  while (
    font.widthOfTextAtSize(truncatedText, fontSize) > width &&
    truncatedText.length > 10
  ) {
    truncatedText =
      truncatedText.substring(0, truncatedText.length - 4) + "...";
  }
  return truncatedText;
};

/**
 * Nettoie le texte pour l'encodage PDF (WinAnsi)
 */
export const cleanTextForPdf = (text: string): string => {
  if (!text) return "";

  return (
    text
      // Normaliser les espaces et sauts de ligne
      .replace(/\r\n/g, "\n") // Windows line endings
      .replace(/\r/g, "\n") // Mac vers Unix
      .replace(/\n{3,}/g, "\n\n") // Réduire les sauts de ligne multiples
      .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "") // Supprimer les caractères de contrôle
      .replace(/\u00A0/g, " ") // Espace insécable → espace normal
      .replace(/[\u2000-\u200B\u2028\u2029\u202F\u205F\u3000]/g, " ") // Autres espaces Unicode

      // Flèches et symboles spéciaux
      // .replace(/→/g, "``->``") // Flèche droite
      .replace(/←/g, "<-") // Flèche gauche
      .replace(/↑/g, "^") // Flèche haut
      .replace(/↓/g, "v") // Flèche bas
      .replace(/➜/g, "``U+279C``") // Flèche TDA Floor
      .replace(/⚠/g, "``U+25B2``") // Triangle d'avertissement TDA Player
      .replace(/…/g, "...") // Points de suspension
      // Guillemets et apostrophes
      .replace(/\u2019/g, "'") // Apostrophe courbe droite (U+2019)
      .replace(/\u2018/g, "'") // Apostrophe courbe gauche (U+2018)
      .replace(/\u201C/g, '"') // Guillemet courbe gauche (U+201C)
      .replace(/\u201D/g, '"') // Guillemet courbe droit (U+201D)
      .replace(/„/g, '"') // Guillemet allemand ouvrant
      .replace(/“/g, '"') // Guillemet allemand fermant
      .replace(/«/g, '"') // Guillemet français ouvrant
      .replace(/»/g, '"') // Guillemet français fermant
      .replace(/‹/g, "'") // Guillemet simple ouvrant
      .replace(/›/g, "'") // Guillemet simple fermant

      // Tirets
      .replace(/–/g, "-") // Tiret en
      .replace(/—/g, "--") // Tiret em

      // Symboles mathématiques et scientifiques
      .replace(/≤/g, "<=") // Inférieur ou égal
      .replace(/≥/g, ">=") // Supérieur ou égal
      .replace(/≠/g, "!=") // Différent
      .replace(/±/g, "+/-") // Plus ou moins
      .replace(/∞/g, "inf") // Infini

      // Nettoyer les espaces multiples
      .replace(/[ \t]{2,}/g, " ") // Espaces multiples → espace simple
      .replace(/\n[ \t]+/g, "\n") // Espaces en début de ligne
      .replace(/[ \t]+\n/g, "\n") // Espaces en fin de ligne

      // Remplacer les caractères non-WinAnsi
      .replace(/[^\x20-\x7E\x80-\xFF\n\t]/g, "?")
      .trimEnd()

    // Syboles spéciaux qui sont accèptés par pdf-lib
    // .replace(/°/g, "deg") // Degré
    // .replace(/µ/g, "u") // Micro
    // .replace(/×/g, "x") // Multiplication
    // .replace(/÷/g, "/") // Division
    // Symboles monétaires et marques
    // .replace(/€/g, "EUR") // Euro
    // .replace(/©/g, "(c)") // Copyright
    // .replace(/®/g, "(R)") // Registered
    // .replace(/™/g, "(TM)") // Trademark
    // Caractères spécifiques aux langues latines
    // .replace(/Œ/g, "OE") // O-E lié majuscule
    // .replace(/œ/g, "oe") // o-e lié minuscule
    // .replace(/ß/g, "ss") // Eszett allemand
  );
};

/**
 * Convertit une couleur hexadécimale en valeurs RGB pour pdf-lib
 */
export const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    console.warn(`Couleur hex invalide: ${hex}, utilisation de #f9f9f2`);
    return (window.PDFLib.rgb as any)(0.99, 0.99, 0.8); // Couleur par défaut
  }
  return (window.PDFLib.rgb as any)(
    parseInt(result[1], 16) / 255,
    parseInt(result[2], 16) / 255,
    parseInt(result[3], 16) / 255
  );
};
